import React, { useEffect } from 'react';
import './index.module.less';
import { loadAnimation } from '@views/components/LottieCreator';
import animation1 from './lottie/sos/data.json';
import animation2 from './lottie/sos2/data.json';
import animation3 from './lottie/sos3/data.json';
import xueshengzheng1 from './lottie/sos/images/xueshengzheng.png';
import xueshengzheng2 from './lottie/sos2/images/xueshengzheng.png';
import { EDeviceVersion } from '@app/types/global.d';

const AnimationConfig = {
  '1': { json: animation1, image: xueshengzheng1 },
  '2': { json: animation2, image: xueshengzheng2 },
  '5': { json: animation3, image: '' },
};
interface IAnimationViewProps {
  type?: EDeviceVersion,
}
const AnimationView = (props: IAnimationViewProps) => {
  const { type = '1' } = props;
  useEffect(() => {
    const currAnimationConfig = AnimationConfig[type] || AnimationConfig['1'];
    const animationData = currAnimationConfig.json;
    const animationImages = currAnimationConfig.image ? [currAnimationConfig.image] : undefined;
    const animation = loadAnimation({
      loop: true,
      autoplay: false,
      container: document.getElementById('lottie'),
      animationData,
    }, animationImages);
    animation.play();
  // eslint-disable-next-line
  },[]);
  
  return (
    <div styleName="container">
      <div className='flex flex-center' styleName='animation-container' id='lottie'></div>
    </div>
  )
}

export default AnimationView;
